module.exports = __webpack_public_path__ + "static/media/pic4Correct.499172cf.mp3";